export default class ISiteLaunchEventData {
    constructor(launchId, location, skuId) {
        this.location = location;
        this.launchId = launchId;
        this.skuId = skuId;
    }
}
